import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function CorbettLuxuryroom() {
    const heading = "Luxury Room";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Corbett Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-corbett/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Luxury Room",
            },
        ]
    }

    const roomBanner = {
        image: "/image/corbett-luxury-room-detail.webp",
    };

    const roomQuote = {
        content: "Our luxury rooms offer a refined stay for small groups or families looking for a solid home base. These rooms are built for rest, featuring high-quality bedding and a layout that focuses on simplicity and ease. It’s the kind of space where you can wake up to the sound of birds and feel completely refreshed and ready for the day's trek.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "37",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/corbett-luxury-room-gallery-1.webp" },
        { image: "/image/corbett-luxury-room-gallery-2.webp" },
        { image: "/image/corbett-luxury-room-gallery-3.webp" },
        { image: "/image/corbett-luxury-room-gallery-4.webp" },

    ];

    const roomEquipment = {
        description: "Designed for a comfortable escape, this room offers a relaxing setting complemented by convenient modern amenities.",
        equipment: [
        [
            "Premium Pocketed Spring Mattress",
            "Daily Coffee and Tea replenishment",
            "42-inch LED TV for entertainment",
            "Mini-Fridge for chilled beverages",
        ],
        [
            "In-Room Electronic Safe",
            "Writing Desk and comfortable chair",
            "Evening Turndown Service on request",
            "Free High-speed Wi-Fi",
        ],
        [
            "Hydropneumatic shower for a great rinse",
            "All-natural Cotton Linens and Duvet",
            "Bidet and modern bathroom fittings",
            "24-Hour Room Service support",
        ]
    ]
    };

    const roomBook = {
        location: "Corbett",
        title: "Luxury Room",
        desc: "Settle into the refined comfort of the Luxury Room at De Coracao Corbett, designed for restful stays with family or friends. Spacious interiors, premium bedding, modern amenities, and a peaceful setting make it an inviting base for your Corbett adventures.",
        details: [
            " 1 King Size Bed + 1 Extra Mattress Allowed",
            "Up to 3 Guests",
            "37 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Club Cottages',
                bg: '/image/corbett-other-room-1.webp',
                slug: '/resort-de-coracao-corbett/club-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress",
                    "Up to 4 Guests",
                    "42 sq.mt",
                ],
            },

            {
                title: 'Premium Cottages',
                bg: '/image/corbett-other-room-2.webp',
                slug: '/resort-de-coracao-corbett/premium-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Cottages',
                bg: '/image/corbett-other-room-3.webp',
                slug: '/resort-de-coracao-corbett/luxury-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "41 sq.mt",
                ],
            },

            {
                title: 'Family Cottages',
                bg: '/image/corbett-other-room-5.webp',
                slug: '/resort-de-coracao-corbett/family-cottages',
                details: [
                    "2 King Size Beds + 1 Extra Mattress Allowed",
                    "Up to 6 Guests",
                    "67 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-corbett/room-listing" }
    }

    return (
        <> 
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
